import { ColumnDef } from '@tanstack/react-table';
import { useNavigate } from 'react-router-dom';

import Table from '../common/Table';
import TableHeader from '../common/TableHeader';
import { IPaginationTable } from '../common/interfaces/IPaginationTable';

import { IStore } from '@/interfaces/api/IStore';
import { ICollectionStore } from '@/interfaces/api/store/ICollectionStore';

const StoreTable = ({
	collectionStore,
	paginationOption,
	columns,
	refetch,
	query,
	setQuery,
	stores,
}: {
	collectionStore: ICollectionStore;
	paginationOption: IPaginationTable;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	columns: ColumnDef<IStore, any>[];
	refetch: () => void;
	query: string;
	setQuery: React.Dispatch<React.SetStateAction<string>>;
	stores: number;
}) => {
	const navigate = useNavigate();

	const handleSelectRow = (selectedStore: IStore) => {
		navigate(`/user/merchants/${selectedStore.tradeName}`);
	};

	return (
		<>
			<TableHeader
				title="Stores List"
				counts={[
					{
						label: 'Total stores',
						value: stores,
						dataTest: 'total-merchants-count',
					},
				]}
				searchConfigs={[
					{
						query: query,
						setQuery: setQuery,
						placeholder: 'Search by store name',
						refetch: refetch,
					},
				]}
			/>
			<div className="mx-2 pb-[2rem] bg-grey-0 border-l border-r border-b border-gray-300 rounded-xl">
				<Table<IStore>
					collection={collectionStore}
					columns={columns}
					paginationSection={paginationOption}
					tableStyles={{
						tableBox: 'w-full border-t overflow-y-auto h-70',
						table: 'w-full',
						tableBody: '',
						tableBodyTr: 'cursor-pointer',
					}}
					handleSelectRow={handleSelectRow}
					dataTest={'stores-table'}
				/>
			</div>
		</>
	);
};

export default StoreTable;
